/**
 * 隧道进度管理 — 树下拉
 * 存在子级分段的隧道名称不可选，仅可选最子级叶子节点。
 */
export function mapTunnelSelectTree (roots) {
  return (roots || []).map((root) => {
    const kids = root.children || []
    const childNodes = kids.map((seg) => ({
      title: seg.name || seg.tunnelName,
      value: seg.id,
      key: String(seg.id)
    }))
    return {
      title: root.name || root.tunnelName,
      value: root.id,
      key: String(root.id),
      disabled: childNodes.length > 0,
      children: childNodes.length ? childNodes : undefined
    }
  })
}

export function filterTunnelTreeNode (input, treeNode) {
  const title = (treeNode.data && treeNode.data.props && treeNode.data.props.title) || ''
  return title.toLowerCase().includes((input || '').toLowerCase())
}

export function buildTunnelTitleMap (nodes, acc = {}) {
  (nodes || []).forEach((n) => {
    if (n.value != null && n.title != null) acc[n.value] = n.title
    if (n.children && n.children.length) buildTunnelTitleMap(n.children, acc)
  })
  return acc
}

/**
 * 租户下【仅存在一条无子级的隧道名称】时返回其 id，用于自动带出。
 * - 两条及以上顶层隧道：不满足
 * - 仅一条顶层隧道但存在分段开挖（有 children）：不满足
 */
export function getUniqueSelectableLeafValue (treeData) {
  const roots = treeData || []
  if (roots.length !== 1) return undefined
  const only = roots[0]
  if (only.children && only.children.length > 0) return undefined
  if (only.disabled) return undefined
  const v = only.value
  if (v === undefined || v === null) return undefined
  return v
}
